export const AUTH_TOKEN = 'devtify-token';
